const round = (number, toFixed) => {
  return +Number(number).toFixed(toFixed);
};

export { round };
